import i18n from 'app/i18n';
import api from '../api';


export const PASSAGES_SHORT_REQUEST = 'PASSAGES_SHORT_REQUEST';
export const PASSAGES_SHORT_SUCCESS = 'PASSAGES_SHORT_SUCCESS';
export const PASSAGES_SHORT_FAILURE = 'PASSAGES_SHORT_FAILURE';

const passagesRequest = () => ({
  type: PASSAGES_SHORT_REQUEST,
});

const passagesSuccess = data => ({
  type: PASSAGES_SHORT_SUCCESS,
  payload: data,
});

const passagesFailure = errString => ({
  type: PASSAGES_SHORT_FAILURE,
  payload: { err: errString },
});

/**
* Запрос данных проходов для приложения "Дети"
*
* @param date дата, за которую будут возвращены проходы
*/
export const fetchPassagesShot = date => (
  async (dispatch) => {
    dispatch(passagesRequest());

    try {
      const passagesData = await api('cabinet/passages/short', 'get', {
        params: { date },
      });
      dispatch(passagesSuccess(passagesData.data));
    } catch (error) {
      dispatch(passagesFailure(i18n.t('app:request_passes_failed')));
    }
  }
);
